import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Types
import { AppDispatch } from 'types/RootState.types';

// Config
import { getSessionExpiredAnnouncedSelector } from '@redux/reducers/app/appSelector';
import { sessionExpiredRedirect } from '@redux/actions/app/appActions';

const SessionTimeoutRedirect = () => {
  const dispatch: AppDispatch = useDispatch();
  const sessionExpiredAnnounced = useSelector(getSessionExpiredAnnouncedSelector);

  const prevSessionExpiredAnnounced = useRef(sessionExpiredAnnounced);

  useEffect(() => {
    if (!prevSessionExpiredAnnounced.current && sessionExpiredAnnounced) {
      dispatch(sessionExpiredRedirect());
    }

    prevSessionExpiredAnnounced.current = sessionExpiredAnnounced;
  }, [sessionExpiredAnnounced]);

  return null;
};

export default SessionTimeoutRedirect;
